import { logConsoleError } from './utils/logger';
import { config } from './config';

// asynchronous tracker (or proxy)
// @ts-expect-error command queue
if (typeof window[config.queueName] !== 'object') {
    // @ts-expect-error command queue 
    window[config.queueName] = [];
}

import trackerObject from './piwik';
// Piwik singleton and namespace
// @ts-expect-error global object name 
if (typeof window[config.objectName] !== 'object') {
    // @ts-expect-error global object name 
    window[config.objectName] = trackerObject;
}

/* pluginTrackerHook */

(function () {
    'use strict';

    function hasPaqConfiguration()
    {
        // @ts-expect-error command queue
        if ('object' !== typeof window[config.queueName]) {
            return false;
        }
        // needed to write it this way for jslint
        // @ts-expect-error command queue
        var lengthType = typeof window[config.queueName].length;
        if ('undefined' === lengthType) {
            return false;
        }

        // @ts-expect-error command queue
        return !!window[config.queueName].length;
    }

    // @ts-expect-error object name
    if (!window[config.objectName].getAsyncTrackers().length) {
        // we only create an initial tracker when no other async tracker has been created yet in piwikAsyncInit()
        if (hasPaqConfiguration()) {
            // we only create an initial tracker if there is a configuration for it via _paq. Otherwise
            // Piwik.getAsyncTrackers() would return unconfigured trackers
            // @ts-expect-error object name
            window[config.objectName].addTracker();
        } else {
            // @ts-expect-error command queue
            window[config.queueName] = {push: function (args) {
                logConsoleError(config.queueName + '.push() was used but Piwik tracker was not initialized before the ppms.js file was loaded. Make sure to configure the tracker via _paq.push before loading ppms.js. Alternatively, you can create a tracker via Piwik.addTracker() manually and then use _paq.push but it may not fully work as tracker methods may not be executed in the correct order.', args);
            }};
        }
    } else {
        logConsoleError(
            'Matomo javascript tracker or Piwik PRO javascript tracker was already initiated on this page. ' +
            'Please check the tracker setup. Matomo conflict can be resolved using these instructions: ' +
            'https://help.piwik.pro/support/questions/can-i-use-piwik-pro-and-matomo-at-the-same-time/.'
        );
    }

    // @ts-expect-error object name
    window[config.objectName].trigger('PiwikInitialized', []);
    // @ts-expect-error object name
    window[config.objectName].initialized = true;
}());


(function () {
    // @ts-expect-error object name
    var jsTrackerType = (typeof window.AnalyticsTracker);
    if (jsTrackerType === 'undefined') {
        // @ts-expect-error AnalyticsTracker, not sure if anyone uses this,
        // better to keep it for backwards compatibility
        window.AnalyticsTracker = window[config.objectName];
    }
}());

import piwikLog from './log';
// @ts-expect-error legacy piwik log
if (typeof window[config.objectName].piwik_log !== 'function') {
    // @ts-expect-error legacy piwik log
    window.piwik_log = piwikLog;
}
